import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ArticlesComponent } from './pages/articles/articles.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { GuidesComponent } from './pages/guides/guides.component';

const routes: Routes = [
  {
    path: 'login-page', component: LoginPageComponent
  },
  {
    path: 'articles', component: ArticlesComponent
  },
  {
    path: 'guides', component: GuidesComponent
  },
  {
    path: '**',
    redirectTo: 'login-page',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
